// Single source of truth for the localStorage keys that hold the auth session,
// so the key names can't drift across the modules that read, write, and clear
// them (e.g. the stale 'auth' key that a hand-rolled logout used to remove).
export const AUTH_STORAGE_KEYS = {
  token: 'authToken',
  refreshToken: 'refreshToken',
  tokenExpiresAt: 'tokenExpiresAt',
  user: 'authUser',
} as const;
